import { combineReducers } from 'redux';
import chatWidget, { CHAT_WIDGET_REDUCER } from './chat-widget/reducer';

export const UI_REDUCER = 'ui';

export const uiReducers = combineReducers({
  [CHAT_WIDGET_REDUCER]: chatWidget,
});
